export default {
  'Your win': 'ชัยชนะของคุณ',
  'Select skins that you want to take': 'เลือกสกินที่คุณต้องการใช้',
  'By price': 'โดยราคา',
  '(Autotrade will receive after 10 minutes)': '(ออโต้เทรดจะได้รับหลังจาก 10 นาที)',
  ACCEPT: 'ยืนยัน',
  'SELECT ALL': 'SELECT ALL',
};
